import { TenantPausedError } from '@/api/ApiClient';
import { checkSuscritionActive, fetchSuscription, SuscriptionDataType } from '@/api/SuscriptionsApi';
import { showAlert } from '@utils/Alert';
import { signIn, confirmSignIn } from 'aws-amplify/auth';
import { SignInInput } from 'aws-amplify/auth';
import { useState } from 'react';
import { logout as sessionLogout } from 'utils/Session';


type AuthStep =
    | 'SIGN_IN'
    | 'NEW_PASSWORD_REQUIRED'
    | 'DONE'
    | 'BLOCKED'
    | 'PAUSED';

export function useAuth() {
    const [authStep, setAuthStep] = useState<AuthStep>('SIGN_IN');
    const [suscriptionData, setSuscriptionData] = useState<SuscriptionDataType>({});

    async function handleSignIn(loginData: SignInInput): Promise<void> {
        try {
            const result = await signIn(loginData);
            if (result.nextStep.signInStep === 'DONE') {
                const profileData = await fetchSuscription();
                setSuscriptionData(profileData);
                const suscriptionActive = await checkSuscritionActive(`${profileData?.id || ""}`)
                if (!suscriptionActive) {
                    setAuthStep('BLOCKED');
                    sessionLogout()
                } else {
                    setAuthStep('DONE');
                }
            } else if (result.nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
                setAuthStep('NEW_PASSWORD_REQUIRED');
                showAlert('info', 'Necesitas establecer una nueva contraseña');
            } else {
                showAlert('danger', 'Usuario o contraseña incorrecta');
            }
        } catch (error: any) {
            if (error instanceof TenantPausedError) {
                setAuthStep('PAUSED');
                showAlert('danger', error.message);
            } else {
                console.error('Error de login:', error);
                let message = 'Ha ocurrido un error inesperado.';

                switch (error.name) {
                    case 'UserNotConfirmedException':
                        message = 'El usuario no ha confirmado su cuenta.';
                        break;
                    case 'PasswordResetRequiredException':
                        message = 'Se requiere restablecer la contraseña.';
                        break;
                    case 'NotAuthorizedException':
                        message = 'Usuario o contraseña incorrecta.';
                        break;
                    case 'UserNotFoundException':
                        message = 'El usuario no existe.';
                        break;
                    default:
                        message = error.message || message;
                }

                showAlert('danger', message);
            }
        }
    }

    async function handleNewPassword(newPassword: string): Promise<void> {

        try {
            const result = await confirmSignIn({
                challengeResponse: newPassword
            });

            if (result.nextStep.signInStep === 'DONE') {
                setAuthStep('DONE');
            }
        } catch (error: any) {
            console.error('Error actualizando contraseña:', error);
            if (error.name === "InvalidPasswordException") {
                showAlert('danger', 'La contraseña no cumple con el estandar para la contraseña. Debe contar al menos con 8 caracteres, una mayuscula, un numero y caracter especial');
            } else {
                showAlert('danger', error.message || 'No se pudo actualizar la contraseña.');
            }

        }
    }

    return {
        authStep,
        suscriptionData,
        handleSignIn,
        handleNewPassword,
    };
}
